import { EntityConfig } from './entity-registry';
import { GenericTableColumn, GenericTableAction } from '../../../../../models/GenericCRUD/GenericTable';
import { GenericFormField } from '../../../../../models/GenericCRUD/GenericForm';
import { Filter } from '../../../../../models/GenericCRUD/Filter';

// Configuración para Plan de Cuentas
const tableColumns: GenericTableColumn[] = [
  { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
  { name: 'Código', active: true, type: 'text', key: 'code', sort: true },
  { name: 'Nombre', active: true, type: 'text', key: 'name', sort: true },
  { name: 'Tipo', active: true, type: 'text', key: 'account_type', sort: true },
  { name: 'Naturaleza', active: true, type: 'text', key: 'nature', sort: true },
  { name: 'Cuenta Padre', active: true, type: 'text', key: 'parent_account.name', sort: false },
  { name: 'Nivel', active: true, type: 'text', key: 'level', sort: true },
  { name: 'Activa', active: true, type: 'boolean', key: 'active', sort: true }
];

const formFields: GenericFormField[] = [
  { name: 'code', type: 'text', label: 'Código de Cuenta', validations: 'required', colspan: 1 },
  { name: 'name', type: 'text', label: 'Nombre de Cuenta', validations: 'required', colspan: 1 },
  {
    name: 'account_type',
    type: 'select',
    label: 'Tipo de Cuenta',
    validations: 'required',
    optionsList: [
      { id: 'asset', name: 'Activo' },
      { id: 'liability', name: 'Pasivo' },
      { id: 'equity', name: 'Patrimonio' },
      { id: 'income', name: 'Ingreso' },
      { id: 'expense', name: 'Gasto' }
    ],
    singleSelection: true,
    colspan: 1
  },
  {
    name: 'nature',
    type: 'select',
    label: 'Naturaleza',
    validations: 'required',
    optionsList: [
      { id: 'debit', name: 'Deudora' },
      { id: 'credit', name: 'Acreedora' }
    ],
    singleSelection: true,
    colspan: 1
  },
  { name: 'parent_account_id', type: 'select', label: 'Cuenta Padre', url: '/chart-of-accounts/all', validations: '', singleSelection: true, colspan: 1 },
  { name: 'level', type: 'number', label: 'Nivel', validations: 'required|min:1|max:5', colspan: 1 },
  { name: 'description', type: 'textarea', label: 'Descripción', validations: '', colspan: 2 },
  { name: 'active', type: 'boolean-switch', label: 'Activa', validations: '', colspan: 2 }
];

const formFieldsEdit: GenericFormField[] = [
  { name: 'code', type: 'text', label: 'Código de Cuenta', validations: 'required', colspan: 1 },
  { name: 'name', type: 'text', label: 'Nombre de Cuenta', validations: 'required', colspan: 1 },
  {
    name: 'account_type',
    type: 'select',
    label: 'Tipo de Cuenta',
    validations: 'required',
    optionsList: [
      { id: 'asset', name: 'Activo' },
      { id: 'liability', name: 'Pasivo' },
      { id: 'equity', name: 'Patrimonio' },
      { id: 'income', name: 'Ingreso' },
      { id: 'expense', name: 'Gasto' }
    ],
    singleSelection: true,
    colspan: 1
  },
  {
    name: 'nature',
    type: 'select',
    label: 'Naturaleza',
    validations: 'required',
    optionsList: [
      { id: 'debit', name: 'Deudora' },
      { id: 'credit', name: 'Acreedora' }
    ],
    singleSelection: true,
    colspan: 1
  },
  { name: 'parent_account_id', type: 'select', label: 'Cuenta Padre', url: '/chart-of-accounts/all', validations: '', singleSelection: true, colspan: 1 },
  { name: 'description', type: 'textarea', label: 'Descripción', validations: '', colspan: 2 },
  { name: 'active', type: 'boolean-switch', label: 'Activa', validations: '', colspan: 2 }
];

const tableActions: GenericTableAction[] = [
  {
    name: 'Editar',
    key: 'edit',
    form: {
      method: 'PUT',
      successTitle: 'Edición correcta',
      errorTitle: 'Error en la edición',
      fields: formFieldsEdit,
      name: 'cuenta',
      createButtonTitle: '',
      cols: 2,
      createApiSlug: '',
      originalUpdateApiSlug: '/chart-of-accounts/update/{{id}}',
      updateApiSlug: '',
      originalFormTitle: 'Editar Cuenta',
      formTitle: 'Editar Cuenta',
      formButtonTitle: 'Guardar',
      width: '3xl'
    },
    completeForm: true,
    replaceAllRowOnResponse: true,
    icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" /><path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" /><path d="M16 5l3 3" /></svg>',
    confirmation: false
  },
  {
    name: 'Eliminar',
    key: 'delete',
    method: 'DELETE',
    icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
    confirmation: true,
    questionText: '¿Desea eliminar esta cuenta contable?',
    deleteRowOnResponse: true,
    actionSlug: '/chart-of-accounts/delete/{{id}}'
  }
];

const filters: Filter[] = [
  { type: 'search', key: 'code|name', operator: 'like', placeholder: 'Código o nombre' },
  {
    type: 'select',
    key: 'account_type',
    operator: 'in',
    placeholder: 'Tipo de Cuenta',
    optionsList: [
      { id: 'asset', name: 'Activo' },
      { id: 'liability', name: 'Pasivo' },
      { id: 'equity', name: 'Patrimonio' },
      { id: 'income', name: 'Ingreso' },
      { id: 'expense', name: 'Gasto' }
    ]
  },
  {
    type: 'select',
    key: 'nature',
    operator: 'in',
    placeholder: 'Naturaleza',
    optionsList: [
      { id: 'debit', name: 'Deudora' },
      { id: 'credit', name: 'Acreedora' }
    ]
  },
  {
    type: 'select',
    key: 'level',
    operator: 'in',
    placeholder: 'Nivel',
    optionsList: [
      { id: '1', name: 'Nivel 1' },
      { id: '2', name: 'Nivel 2' },
      { id: '3', name: 'Nivel 3' },
      { id: '4', name: 'Nivel 4' },
      { id: '5', name: 'Nivel 5' }
    ]
  }
];

/**
 * Configuración completa de la entidad Plan de Cuentas
 */
export const chartOfAccountsConfig: EntityConfig = {
  id: 'chart-of-accounts',
  name: 'Plan de Cuentas',
  icon: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>',

  tableColumns,
  formFields,
  formFieldsEdit,
  tableActions,
  filters,

  form: {
    successTitle: 'Cuenta creada correctamente',
    errorTitle: 'Error al crear cuenta',
    method: 'POST',
    fields: formFields,
    name: 'cuenta',
    createButtonTitle: 'Nueva Cuenta',
    cols: 2,
    createApiSlug: '/chart-of-accounts/store',
    formTitle: 'Crear Cuenta Contable',
    formButtonTitle: 'Crear Cuenta',
    width: '3xl'
  },

  table: {
    columns: tableColumns,
    items: [],
    type: 'generic',
    loadItemsSlug: '/chart-of-accounts/index',
    paginate: true,
    name: 'cuentas',
    actions: tableActions,
    // Sin vista de detalle: no existe esa ruta (evita ir al dashboard al hacer clic).
    details: false
  },

  useModalForm: false
};
